export enum DealTransactionType {
  RETAIL = 'Retail',
  BALLOON_PAYMENT = 'Balloon Payment',
}
